
import { defineComponent } from "vue";
import { ICountriesModel, IUsersModel } from "@/interfaces/modules";
import CountriesService from "@/api/Location/CountriesService";
import store from "@/store";

export default defineComponent({
  name: "App",
  data() {
    return {
      systemUsers: [] as IUsersModel[],
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as ICountriesModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
          {
            key: "Name",
            label: "Nombre",
            sortable: true,
          },
          {
            key: "CodeCountry",
            label: "Código del país",
            sortable: true,
          },
          {
            key: "CodeISO",
            label: "Código ISO",
            sortable: true,
          },
          {
            key: "Enable",
            label: "Activo",
            sortable: true,
          },
          {
            key: "CreatedByFormat",
            label: "Creación",
            sortable: true,
          },
          {
            key: "ModifiedByFormat",
            label: "Ultima modificación",
            sortable: true,
          },
          {
            key: "action",
            label: "Acciones",
            sortable: false,
          },
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
          (item: any) =>
            item.Name.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            ) ||
            item.CodeISO.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            )
        )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await CountriesService.GetCountries();
      this.table.loading = false;
    },
    async edit(data: ICountriesModel) {
      this.form.record = await CountriesService.GetCountriesById(data);
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Enable: true } as ICountriesModel;
      this.form.dialog = true;
    },
    validateState(field: any): boolean {
      return this.form.record[field]?.length > 0 ? true : false;
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.form.dialog = false;
      await CountriesService.PostCountries(this.form.record);
      store.dispatch("core/popupDialog", {
        text: "Registro completado con éxito.",
        type: "success",
        showCancelButton: false,
      });

      this.load();
    },
  },
});
